// @flow
import type { ResourceType } from '../types/resource';
import type { Action } from '../types/actions';
import resourceService from '../services/resource-service';

// action creators (not exported)
function resourcesRequest(): Action { return { type: 'GET_RESOURCES_REQUEST' }; }
function resourcesSuccess(resources): Action { return { type: 'GET_RESOURCES_SUCCESS', resources }; }
function resourcesError(error): Action { return { type: 'GET_RESOURCES_ERROR', error }; }

function singleAggregatedResource(resource): Action { return { type: 'GET_SINGLE_AGGREGATED_RESOURCE', resource }; }

function singleResourceRequest(): Action { return { type: 'GET_SINGLE_RESOURCE_REQUEST' }; }
function singleResourceSuccess(resource): Action { return { type: 'GET_SINGLE_RESOURCE_SUCCESS', resource }; }
function singleResourceError(error): Action { return { type: 'GET_SINGLE_RESOURCE_ERROR', error }; }

// thunks
const fetchResources = () => (dispatch) => {
  dispatch(resourcesRequest());
  resourceService
    .all()
    .then((resources: ResourceType[]) => {
      dispatch(resourcesSuccess(resources));
    })
    .catch((err) => {
      dispatch(resourcesError(err));
    });
};

const fetchSingleResource = (id: number) => (dispatch) => {
  dispatch(singleResourceRequest());
  resourceService
    .show(id)
    .then((resource: ResourceType) => {
      dispatch(singleResourceSuccess(resource));
    })
    .catch((err) => {
      dispatch(singleResourceError(err));
    });
};

const fetchAggregatedResource = (resource) => (dispatch) => {
  dispatch(singleAggregatedResource(resource));
};

const fetchResourceInclParams = (id: number, params: string) => (dispatch) => {
  dispatch(singleResourceRequest());
  resourceService
    .include(id, params)
    .then((resource: ResourceType) => {
      dispatch(singleResourceSuccess(resource));
    })
    .catch((err) => {
      dispatch(singleResourceError(err));
    });
};

const fetchAllResourcesExclParams = (params: string) => (dispatch) => {
  dispatch(resourcesRequest());
  resourceService
    .exclude(params)
    .then((resources: ResourceType[]) => {
      dispatch(resourcesSuccess(resources));
    })
    .catch((err) => {
      dispatch(resourcesError(err));
    });
};

export {
  fetchResources,
  fetchSingleResource,
  fetchAggregatedResource,
  fetchResourceInclParams,
  fetchAllResourcesExclParams
};


// WEBPACK FOOTER //
// ./src/actions/resources.js